import React from 'react';
import "./App.css";
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ServicesSection from './components/ServicesSection';
import StationsSection from './components/StationsSection';
import AboutSection from './components/AboutSection';
import PartnersSection from './components/PartnersSection';
import EngagementsSection from './components/EngagementsSection';
import EcosystemSection from './components/EcosystemSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <StatsSection />
        <ServicesSection />
        <StationsSection />
        <AboutSection />
        <PartnersSection />
        <EcosystemSection />
        <EngagementsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
